import { useCallback, useEffect, useState } from 'react';
import { fetchProducts } from '../services/integrationService';

// Carrega o catálogo completo de produtos uma vez — usado tanto para exibir
// a contagem total quanto como base para a busca e para a sincronização em
// lote.
export function useProductCatalog() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadProducts = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchProducts();
      setProducts(data || []);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadProducts();
  }, [loadProducts]);

  return { products, count: products.length, loading, error, refetch: loadProducts };
}
